if (!customElements.get('softmorrow-product')) {
  customElements.define('softmorrow-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('[data-sm-variant]');
      if (!this.select) return;
      this.form = this.querySelector('form');
      this.onSubmit = event => this.addSelectedPack(event);
      this.form.addEventListener('submit', this.onSubmit);
      this.addEventListener('change', () => this.update());
      this.section = this.closest('.sm-product-section');
      this.onShadeClick = event => {
        const button = event.target.closest('[data-sm-shade]');
        if (!button) return;
        const option = [...this.select.options].find(option => option.textContent.toLowerCase().includes(button.dataset.smShade.toLowerCase()));
        if (option) {
          this.select.value = option.value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      this.section.addEventListener('click', this.onShadeClick);
      const requestedVariant = new URLSearchParams(location.search).get('variant');
      if (requestedVariant && [...this.select.options].some(option => option.value === requestedVariant)) this.select.value = requestedVariant;
      this.update();
      this.sticky = this.querySelector('[data-sm-sticky]');
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.sticky.hidden = this.querySelector('.sm-add').getBoundingClientRect().bottom >= 0;
          this.frame = null;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.section?.removeEventListener('click', this.onShadeClick);
      this.form?.removeEventListener('submit', this.onSubmit);
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.ready = false;
    }
    update() {
      const option = this.select.selectedOptions[0];
      const price = Number(option.dataset.price);
      const quantity = Number(this.querySelector('input[name="quantity"]:checked').value);
      const trio = quantity === 3;
      const selectedOptions = trio ? [option, ...[...this.querySelectorAll('[data-sm-trio-variant]')].map(select => select.selectedOptions[0])] : [option];
      const counts = new Map();
      selectedOptions.forEach(selected => counts.set(selected.value, (counts.get(selected.value) || 0) + 1));
      const available = selectedOptions.every(selected => selected.dataset.available === 'true' && counts.get(selected.value) <= Number(selected.dataset.max));
      const trioPanel = this.querySelector('[data-sm-trio-colors]');
      trioPanel.hidden = !trio;
      this.querySelector('[data-sm-first-label]').textContent = trio ? 'Option 1 — color' : 'Choose your color';
      const offerNote = this.querySelector('[data-sm-offer-note]');
      if (offerNote) offerNote.textContent = trio ? 'Your third comb is free. Discounts apply automatically in your cart.' : 'Your 30% discount applies automatically in your cart.';
      const offerActive = this.dataset.offer === 'true' && this.dataset.currency === 'USD';
      const singleSale = price;
      const trioPrices = [option, ...[...this.querySelectorAll('[data-sm-trio-variant]')].map(select => select.selectedOptions[0])].map(selected => Number(selected.dataset.price));
      const trioRegular = trioPrices.reduce((total, amount) => total + amount, 0);
      const totalTriple = offerActive ? trioRegular - Math.min(...trioPrices) : trioRegular;
      const selectedTotal = quantity === 3 ? totalTriple : singleSale;
      const format = n => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(n / 100);
      this.querySelector('[data-sm-price]').textContent = format(selectedTotal);
      const original = this.querySelector('[data-sm-original]');
      if (original) original.textContent = format(Math.round((trio ? trioRegular : price) / 0.7));
      this.querySelector('[data-sm-single]').textContent = format(singleSale);
      this.querySelector('[data-sm-triple]').textContent = format(totalTriple);
      this.querySelectorAll('button[type="submit"]').forEach(button => button.disabled = !available || this.adding);
      this.querySelector('[data-sm-pack-error]').hidden = true;
      this.querySelector('[data-sm-sticky-add]').textContent = available ? this.dataset.add : this.dataset.soldOut;
      this.querySelector('[data-sm-sticky-color]').textContent = trio ? selectedOptions.map(selected => selected.textContent.trim()).join(' / ') : option.textContent.trim();
      this.querySelector('[data-sm-sticky-price]').textContent = format(selectedTotal);
      this.querySelector('[data-sm-submit]').textContent = available ? this.dataset.add : this.dataset.soldOut;
      this.closest('.sm-product-section').querySelectorAll('[data-sm-shade]').forEach(button => button.setAttribute('aria-pressed', String(option.textContent.toLowerCase().includes(button.dataset.smShade.toLowerCase()))));
      const image = this.closest('.sm-product-section').querySelector('[data-sm-main-photo] img');
      if (option.dataset.image && image) {
        image.classList.add('sm-custom-image');
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.imageAlt || option.textContent.trim();
        if (option.dataset.imageSrcset) {
          image.srcset = option.dataset.imageSrcset;
          image.sizes = '(max-width: 749px) calc(100vw - 44px), 530px';
        }
      }
    }
    async addSelectedPack(event) {
      if (this.querySelector('input[name="quantity"]:checked').value !== '3') return;
      event.preventDefault();
      if (this.adding) return;
      const selected = [this.select, ...this.querySelectorAll('[data-sm-trio-variant]')].map(select => select.selectedOptions[0]);
      const items = [...selected.reduce((grouped, option) => {
        const id = Number(option.value);
        grouped.set(id, { id, quantity: (grouped.get(id)?.quantity || 0) + 1 });
        return grouped;
      }, new Map()).values()];
      this.adding = true;
      this.update();
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Could not add the selected combs. Please try again.');
        }
        window.location.assign(root + 'cart');
      } catch (error) {
        const message = this.querySelector('[data-sm-pack-error]');
        message.textContent = error.message || 'Could not add the selected combs. Please try again.';
        this.adding = false;
        this.update();
        message.hidden = false;
      }
    }
  });
}
